module.exports = __webpack_public_path__ + "static/img/101416.75089e69.png";